import AaSequence from 'molbio/aa-sequences/AaSequence';
import {PolymerTabState, PolymerTabStateAttributes} from 'molbio/tabstates/PolymerTabState';
import {TabStateDefaults} from 'Navigation';

import type {ViewState} from './AlphaFoldTabView';

export interface AlphaFoldTabStateAttributes extends PolymerTabStateAttributes<AaSequence> {
  initialView?: ViewState;
}

interface AlphaFoldTabState {
  get<K extends keyof AlphaFoldTabStateAttributes>(key: K): AlphaFoldTabStateAttributes[K];
  set<K extends keyof AlphaFoldTabStateAttributes>(
    attributeName: K,
    value: AlphaFoldTabStateAttributes[K],
    options?: Backbone.ModelSetOptions
  ): AlphaFoldTabState;
  set(obj: Partial<AlphaFoldTabStateAttributes>): AlphaFoldTabState;
}

class AlphaFoldTabState extends PolymerTabState<AaSequence> {
  override defaults(): TabStateDefaults {
    return {
      ...super.defaults(),
      title: '3D Structure',
      closeable: false,
      preferenceKey: 'protein-structure',
    };
  }
}

export default AlphaFoldTabState;
